<template>
	<div class="containerMain">
		<title-bar :topTitle="true"/>
		<div class="col inner" v-if="academicLevelSummary && academicLevelProgress">
			<title-bar title="Progreso" :percentage="academicLevelSummary.schoolPercentage" percentageTitle="Promedio Colegio"/>
			<title-bar :title="academicLevelSummary.itemName" :percentage="academicLevelSummary.itemPercentage" percentageTitle="Promedio Nivel"/>
			<div class="col between innerRubric">
				<chart :properties="chartProperties" height="40%" width="100%"></chart>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	props: ['academicLevelId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		academicLevelSummary () {
			if (this.$store.state.academicLevels.summary) return this.$store.state.academicLevels.summary.find((item) => {
				return item.itemId == this.academicLevelId;
			});
			else this.$store.state.academicLevels.summary;
		},
		academicLevelProgress () {
			if (this.$store.state.academicLevels.progress) return this.$store.state.academicLevels.progress.find((item) => {
				return item.academicLevel.id == this.academicLevelId;
			}).progress;
			else this.$store.state.academicLevels.progress;
		},
		chartProperties () {
			return {
				type: 'line',
				data: {
					labels: this.academicLevelProgress.map((visit) => {
						return `Visita ${visit.number}: ${parseInt(visit.percentage)}%`;
					}),
					datasets: [{
						data: this.academicLevelProgress.map((visit) => {
							if (visit.coachingCategories.length > 0) return parseInt(visit.percentage);
							else return null;
						}),
						backgroundColor: 'rgba(74, 144, 226, 0.45)',
						borderColor: 'rgba(74, 144, 226, 1)',
						borderWidth: 2,
						dates: this.academicLevelProgress.map((visit) => {
							return this.getHumanDate(visit.date);
						})
					}]
				},
				options: {
					legend: {
						display: false
					},
					tooltips: {
						backgroundColor: 'rgba(74, 144, 226, 1)',
						borderColor: 'rgba(81, 95, 122, 0.1)',
						borderWidth: 2,
						bodyFontColor: 'white',
						caretSize: 8,
						cornerRadius: 2,
						defaultFontSize: 14,
						displayColors: false,
						enabled: true,
						position: 'nearest',
						titleFontColor: 'white',
						xPadding: 10,
						yPadding: 10,
						callbacks: {
							title: function (tooltipItem, data) {
								return `${data.datasets[0].dates[tooltipItem[0].index]}`;
							},
							label: function (tooltipItem) {
								return `${tooltipItem.yLabel}%`;
							},
							afterLabel: function (tooltipItem, data) {
								if (tooltipItem.index === 0) return '';
								let previousValue = data.datasets[0].data[tooltipItem.index - 1];
								let difference = tooltipItem.yLabel - previousValue;
								let progress = (parseInt(difference) * 100) / parseInt(previousValue);
								return difference <= 0 ? (difference == 0 ? `${-1 * parseInt(progress)}% ` : `- ${-1 * parseInt(progress)}% `) : `+ ${parseInt(progress)}% `;
							}
						}
					},
					scales: {
						xAxes: [{
							gridLines: {
								color: 'rgba(81, 95, 122, 0.2)',
								lineWidth: 1
							}
						}],
						yAxes: [{
							ticks: {
								display: true,
								beginAtZero: true,
								max: 100,
								stepSize: 25
							},
							gridLines: {
								color: 'rgba(81, 95, 122, 0.2)',
								lineWidth: 1
							}
						}]
					}
				}
			};
		}
	},
	methods: {
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		}
	}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/routes/academicLevels/Progress.vue